import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        user: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false
      }
  },
  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    preset() {
        var credentials = {
            session_key: localStorage.getItem("sp_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    data.forEach(function(element) {
                       this.user.user_id = element.user_id;
                       this.user.user_name = localStorage.getItem("sp_user");
                        this.loggedIn = true;
                    }, this);
                }else {
                   //this.$router.push('login');
                  }
            }).catch((err) => {
                if(err) {
                    //this.$router.push('login');
                }
            })
        }else {
           //this.$router.push('login');
        }
    },

    setMarketRemote(){
        service.getBusinessByUserName(this, service.market_app_name).then(response => {
            if(response.body.status == 200) {
                this.market = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    
  },
  created: function() {
    this.preset();
    this.setMarketRemote();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainSidebar/script.js